export const metadataQueryConfig = {
  staleTime: Infinity,
};
